import React, { Component } from 'react';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class TabSelector extends Component {
  constructor() {
    super();
    this.state = {
      bureau: []
    }
  }

  componentDidMount = () => {
    fetch(SERVER_ADDRESS + '/bureaux')
      .then(res => res.json())
      .then(res => this.setState({ bureau: res }))
  }

  render() {
    return (
      <div className="TabSelector">
        {this.state.bureau.map((bureaux, index) => (
          <button
            key={index}
            id={bureaux.ville}
            onClick={this.props.handleChangeTab}
            className={this.props.activeId === `${bureaux.ville}` ? 'active' : ''}
          >
            {bureaux.ville}
          </button>
        ))}
      </div>
    );
  }
}

export default TabSelector;
